<script>
export default {
}
</script>
<template>
  <icon-base>
    <g>
      <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
    </g>
  </icon-base>
</template>